import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import axios from 'axios'
import { withRouter } from 'react-router-dom'
import { URL } from '../../const'
import Loader from '../_common/Loader'
import _ from 'lodash'

export class PropertyResidents extends PureComponent {
  constructor (props) {
    super(props)

    this.state = {
      loading: true,
      data: [],
      orderDesc: false
    }
  }
  componentDidMount () {
    this._fetchData()
  }

  async _fetchData () {
    this.setState({ loading: true })
    const headers = {
      'Authorization': `Token ${this.props.user.token}`
    }
    const url = `${URL}residents?property_id=${this.props.propertyID}`
    try {
      const res = await axios.get(
        url,
        { headers }
      )
      const data = res.data.items

      // console.log('res: ', res)
      this.setState({ data: this._orderData(data), loading: false })
    } catch (error) {
      console.log('An error occured while fetching residents data.')
    }
  }

  _orderData (data) {
    if (this.state.orderDesc) {
      return _.orderBy(data, 'room_no', ['desc'])
    } else {
      return _.orderBy(data, 'room_no', ['asc'])
    }
  }
  _handleEditResident (id) {
    this.props.history.push(`/residents/${id}`)
  }

  _handleFilterClick = (order) => {
    switch (order) {
      case 'asc':
        this.setState({ orderDesc: false })
        break
      case 'desc':
        this.setState({ orderDesc: true })
        break
      default:
        break
    }
  }

  _renderFetchedCard () {
    if (this.state.data) {
      const sortedData = this._orderData(this.state.data)
      return sortedData.map(item => {
        let wifiStatus
        switch (item.wifi_installation_status) {
          case 0:
            wifiStatus = '未着手'
            break
          case 1:
            wifiStatus = '工事中'
            break
          case 2:
            wifiStatus = '完了'
            break
          default:
            wifiStatus = '未登録'
            break
        }
        return (
          <article className="resident_card flex column" key={`${item.room_no}_${item.name}`} onClick={() => { this._handleEditResident(item.id) }}>
            <div className="tag_container">
              <div className="tag small">{ wifiStatus }</div>
            </div>
            <div className="room_number label_group flex column">
              <span className="label">部屋番号</span>
              <span className="value">{item.room_no}</span>
            </div>
            <div className="resident label_group flex column">
              <span className="label">氏名</span>
              <span className="value">{item.name}</span>
            </div>
          </article>
        )
      })
    }
  }

  _renderEmptyCard () {
    let emptyCards = []
    for (let i = 0; i < this.props.roomCount - this.state.data.length; i++) {
      emptyCards.push(
        <article
          key={`empty_${i}`}
          className="resident_card flex empty_card align-center justify-center"
          onClick={() => this.props.history.push(`${this.props.location.pathname}/add`)}
        >
          未登録
        </article>
      )
    }
    return emptyCards
  }

  _renderCards () {
    return [
      this._renderFetchedCard(),
      this._renderEmptyCard()
    ]
  }

  render () {
    return [
      <div className="filter_container" key="filter">
        <span>部屋番号の並び替え：</span>
        <div className={`${this.state.orderDesc ? 'active ' : ''}desc`} onClick={() => { this._handleFilterClick('desc') }}>
          <span>降順</span>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <line x1="12" y1="5" x2="12" y2="19"></line>
            <polyline points="19 12 12 19 5 12"></polyline>
          </svg>
        </div>
        <div className={`${this.state.orderDesc ? '' : 'active '}asc`} onClick={() => { this._handleFilterClick('asc') }}>
          <span>昇順</span>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <line x1="12" y1="19" x2="12" y2="5"></line>
            <polyline points="5 12 12 5 19 12"></polyline>
          </svg>
        </div>
      </div>,
      <section className="resident_list flex" key="resident_list">
        {
          this.state.loading
            ? <Loader classname="loader_dot_circle"/>
            : this._renderCards()
        }
      </section>
    ]
  }
}

// export default PropertyResidents
function mapStateToProps ({ user }) {
  return { user }
}

export default withRouter(connect(mapStateToProps, null)(PropertyResidents))



// WEBPACK FOOTER //
// ./src/components/Properties/PropertyResidents.js